import React from 'react';
import { Box } from '../../../../../../CommonComponents/OPL/Box/Box';
import { Text } from '../../../../../../CommonComponents/OPL/Text/Text';
import { Chart } from './components/Chart/Chart';
import { Table } from './components/Table/Table';
import { LoadingLongevityAnalysis } from './LongevityAnalysis.loading';
import { useClientId } from '../../../../../../_hooks/useClientId';
import { useFpId } from '../../../../../hooks/useFpId';
import { useLongevityAnalysisQuery } from '../../../../api/useLongevityAnalysisQuery';
import { ErrorState } from '../../../../../../CommonComponents/OPL/AsyncStates/ErrorState/ErrorState';

export const LogevityAnalysis = () => {
  const clientId = useClientId();

  const fpId = useFpId();

  const { isFetching, data, error, refetch } = useLongevityAnalysisQuery({
    clientId,
    fpId,
  });

  if (isFetching) {
    return <LoadingLongevityAnalysis />;
  }

  if (error) {
    return (
      <Box display="flex" alignItems="center" justifyContent="center" py="24" height="100%">
        <ErrorState onAction={refetch} />
      </Box>
    );
  }

  if (!data) {
    return null;
  }

  return (
    <Box position="relative">
      <Box display="flex" flexDirection="column" css={({ theme }) => ({ gap: theme.space['16'] })}>
        <Text variant="cardTitle" pt="32" pb="4">
          Probability of Annual Success
        </Text>

        <Chart />

        <Table />
      </Box>
    </Box>
  );
};
